import { toaster } from '@/components/ui/toaster';
import { useCallback } from 'react';

export const useDepositsAndWithdrawalsToasts = () => {
  const getSuccessToast = useCallback(
    ({ actionName, destinationName }: { actionName: string; destinationName: string }) => {
      toaster.create({
        type: 'success',
        title: 'Transaction Successfully Submitted',
        description: `Your ${actionName} has been successfully submitted. Your ${destinationName} should reflect this in a few moments.`,
      });
    },
    [],
  );
  const getErrorToast = useCallback(({ actionName, errorMessage }: { actionName: string; errorMessage: string }) => {
    toaster.create({
      type: 'error',
      title: 'Transaction Failed',
      description: `Your ${actionName} has failed. Error: ${errorMessage}`,
    });
  }, []);
  return {
    getSuccessToast,
    getErrorToast,
  };
};
